export default __webpack_public_path__ + "static/media/icons-connection-active.1c108917.svg";